import memoize from 'memoizee';
import config from '@/constants/config';
import pools from '@/constants/pools';
import REFERENCE_ASSETS from '@/constants/reference-assets.js';
import getFactoryV2Gauges from '@/utils/data/getFactoryV2Gauges';

const mainUiPoolsAddresses = pools.map(({ addresses }) => addresses.swap.toLowerCase());

// import { IS_DEV } from '@/constants/AppConstants';

const getFactoryCryptoPools = memoize(async () => {
    const hasFactoryRegistry = !!config.factoryCryptoRegistryAddress;
    if (!hasFactoryRegistry) return [];

    const [
        { data: { poolDetails: apyData } },
        { data: { poolData } },
        gaugesData,
    ] = await Promise.all([
        (await fetch(config.factoryCryptoApyEndpoint)).json(),
        (await fetch(config.factoryCryptoPoolsEndpoint)).json(),
        getFactoryV2Gauges(),
    ]);

    // On facto v2 facto gauges endpoints, there's a factory prop on ethereum, but not sidechains because sidechains
    // use a factory-only endpoint where all gauges are factory gauges
    const factoryGaugesData = (Array.isArray(gaugesData) ? gaugesData : Array.from(Object.values(gaugesData))).filter(({ factory }) => config.blockchainId !== 'ethereum' || factory === true);

    const augmentedData = poolData.map((poolInfo, i) => {
        const factoryGaugeData = factoryGaugesData.find(({ swap }) => swap.toLowerCase() === poolInfo.address.toLowerCase());

        return {
            ...poolInfo,
            name: `Factory:${poolInfo.name.split(/pool:/i)[1]}`,
            referenceAsset: REFERENCE_ASSETS.CRYPTO,
            apy: (
                (apyData[i]?.apyWeekly && apyData[i]?.apy) ?
                    Math.max(apyData[i].apyWeekly, apyData[i].apy) :
                    (apyData[i]?.apyWeekly || apyData[i]?.apy || 0)
            ),
            apyWeekly: (apyData[i]?.apyWeekly || 0),
            volume: apyData[i]?.volume || 0,
            coinsAddresses: poolInfo.coinsAddresses.filter((address) => address !== '0x0000000000000000000000000000000000000000'),
            gauge: factoryGaugeData?.gauge,
            rewardsNeedNudging: factoryGaugeData?.rewardsNeedNudging,
            areCrvRewardsStuckInBridge: factoryGaugeData?.areCrvRewardsStuckInBridge,
            gaugeRewards: factoryGaugeData?.extraRewards || poolInfo.gaugeRewards,
        };
    });

    const filteredData = augmentedData.filter(({ address }) => {
        const lcAddress = address.toLowerCase();
        const isMainUiPool = mainUiPoolsAddresses.some((address) => address === lcAddress);

        return !isMainUiPool;
    });

    return filteredData;
}, {
    promise: true,
    maxAge: 60 * 1000, // 1m
});

export default getFactoryCryptoPools;
